/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
// we need to use tabindex on popup ^^ so it could be interactable right away
// when it's appears
import Dropdown from 'react-dropdown';
import PropTypes from 'prop-types';
import React, { useEffect, useRef } from 'react';
import 'react-dropdown/style.css';

import { updateURLQueryParams } from '../../common/navigation/navigation';
import { classesType } from '../../constants/prop-types';

import { openOnEnterKeyPressedOnDropdown } from '../../common/utils/dropDownHelpers';

const onClassSelect = selectClassId => ({ value: classId }) => {
    selectClassId(classId);
    updateURLQueryParams({ classId, classeId: undefined, studentId: undefined });
};

const getOptions = classes => classes.map(cl => ({ value: cl.id, label: cl.name }));

const ClassList = ({ classes, selectedClassId, selectClassId }) => {
    const dropdownReactRef = useRef(null);

    const isDevEnv = process.env.NODE_ENV === 'development';
    const dashboardPrefix = isDevEnv ? '' : 'dashboard-';

    const dropdownWrapperSelector = `.${dashboardPrefix}classes-dropdown-wrapper`;

    const dropdown = document.querySelector(dropdownWrapperSelector);

    useEffect(() => {
        if (dropdown) {
            dropdown.addEventListener(
                'keydown',
                openOnEnterKeyPressedOnDropdown(dropdownReactRef, dropdown),
            );
        }
        return () => {
            if (dropdown) {
                dropdown.removeEventListener(
                    'keydown',
                    openOnEnterKeyPressedOnDropdown(dropdownReactRef, dropdown),
                );
            }
        };
    }, [dropdown]);

    return (
        <div className='dashboard-classes-dropdown-wrapper' tabIndex={0}>
            <Dropdown
                arrowClassName='dashboard-dropdown-arrow'
                controlClassName='dashboard-classes-dropdown'
                onChange={onClassSelect(selectClassId)}
                options={getOptions(classes)}
                placeholderClassName='dashboard-dropdown-text'
                value={selectedClassId}
                ref={dropdownReactRef}
            />
        </div>
    );
};

ClassList.propTypes = {
    classes: classesType.isRequired,
    selectedClassId: PropTypes.string.isRequired,
    selectClassId: PropTypes.func.isRequired,
};

export default ClassList;
